const LEVEL_KEY = "kanalearn.jlptLevel.v1";

export function getJlptLevel(): string | null {
    try {
        return localStorage.getItem(LEVEL_KEY) || null;
    } catch {
        return null;
    }
}

export function setJlptLevel(level: string | null): void {
    try {
        if (level) {
            localStorage.setItem(LEVEL_KEY, level);
        } else {
            localStorage.removeItem(LEVEL_KEY);
        }
    } catch {
        // Best-effort: if storage is unavailable, the preference just won't persist.
    }
}
